import { render } from "./readOnlyDocumentEditor.vue?vue&type=template&id=ac55e450&scoped=true"
import script from "./readOnlyDocumentEditor.vue?vue&type=script&lang=js"
export * from "./readOnlyDocumentEditor.vue?vue&type=script&lang=js"

import "./readOnlyDocumentEditor.vue?vue&type=style&index=0&id=ac55e450&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac55e450"]])

export default __exports__